import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IWalkThroughPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  desktop_bg_image?: string;
  mobile_bg_image?: string;
  alt_image?: string;
  title_prefix?: string;
  title_highlight?: string;
  title_suffix?: string;
  title_highlight_color?: string;
  video_link?: string;
  cta_label?: string;
  overlay_color?: string;
  overlay_opacity?: number;
  status?: boolean;
}

export async function createWalkThrough(payload: Partial<IWalkThroughPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.WALK_THROUGH.CREATE,
      payload,
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateWalkThrough(
  id: number,
  payload: Partial<IWalkThroughPayload>,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.WALK_THROUGH.UPDATE(id),
      payload,
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
